import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { shallow } from 'zustand/shallow';
import styles from "./login.module.css"
import appLogo from "../../assets/images/agencia_nacional_digital.png";
import loginImage from "../../assets/images/agencia_nacional_digital.png";
import iconPassView from "../../assets/login/icon-pass-view.svg";
import iconPass from "../../assets/login/icon-pass.svg";
import iconPerson from "../../assets/login/icon-person.svg";
import { useAuth } from "../../contexts/AuthContext";
import { useUserStore } from "../../store/user.store";
import LoadingInformation from "../../common/UI/LoadingInformation";
import { LoginService } from "../services/loginByrut.service";
import { toast } from "react-toastify";
import AppGetIcon from "../../common/UI/AppGetIcon";
import ProgressBar from "../../common/UI/ProgressBar";

const loginService = new LoginService();

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<{ textUser: string, textPass: string }>({ textUser: "", textPass: "" });
  const [error, setError] = useState("");
  const [messageDescription, setMessageDescription] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [errorType, setErrorType] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();


  const handleInputChange = (e: any) => {
    const { id, value } = e.target;
    setForm({ ...form, [id]: value });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setErrorType(null);
    setMessageDescription("");
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await loginService.run({ email: form.textUser, password: form.textPass });
          const accessToken = response.accessToken;
          const refreshToken = response.refreshToken; // Si tu API lo devuelve

          localStorage.setItem('authToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);

          // Guardar token y el estado de autenticación en cookies
          login(accessToken);


       toast.success(
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AppGetIcon name="checkCircleFill" />
          {response.responseServiceDescription?? 'Bienvenido de nuevo!'}
        </div>,
        { icon: false }
      );
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || "Error";
      toast.error(
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AppGetIcon name="xCircleFill" />
          {errorMessage}
        </div>,
        { icon: false }
      );
    } finally {
      setLoading(false);
    }
   
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={styles.login}>
      {loading && <ProgressBar />}
      <div className={styles.loginFondo}>
        <div className={styles.loginFondoImg}>
          <div
            className={styles.imgFondo}
          ></div>
        </div>

      </div>
      <div className={styles.loginContainer}>
        <div className={styles.loginContent}>
          <div className={styles.loginHeader}>
            <Link to="/">
              <div className={styles.formLogo}>
                <img className={styles.logoIcon} src={appLogo} alt="App Logo" />
              </div>
            </Link>
            <div className={styles.loginHeaderTitle}>
              <div className={styles.formTitle}>¡Bienvenido de nuevo!</div>
            </div>
          </div>
          <div className={styles.loginBody}>
            <form>
              <div className={styles.loginInputs}>
                <div className={styles.inputUser}>
                  <input
                    type="text"
                    className={styles.formInput}
                    id="textUser"
                    placeholder=" "
                    value={form.textUser}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="textUser" className={styles.formLabel}>
                    User
                  </label>
                  <span className={styles.formIcon}>
                    {" "}
                    <img className={styles.contentIcon} src={iconPerson} alt="Hide Password" />
                  </span>{" "}
                  {/* Placeholder for icon */}
                </div>

                <div className={styles.inputPassword}>
                  <input
                    type={showPassword ? "text" : "password"}
                    className={styles.formInput}
                    id="textPass"
                    placeholder=" "
                    value={form.textPass}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="textPass" className={styles.formLabel}>
                    Password
                  </label>
                  <button
                    className={styles.formIcon}
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <img className={styles.contentIcon} src={iconPassView} alt="Hide Password" />
                    ) : (
                      <img className={styles.contentIcon} src={iconPass} alt="Show Password" />
                    )}
                  </button>
                </div>

                <div className={styles.inputRemember}>
                  <input
                    type="checkbox"
                    className={styles.formCheckbox}
                    id="Remember"
                  />
                  <label htmlFor="Remember">Recuerdame</label>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.loginFooter}>
            <div className={styles.loginButtons}>
              <div className={styles.buttonLogin}>
                <button
                  className={`${styles.buttonLoginStart} ${loading ? styles.disableBtn : ""
                    }`}
                  disabled={loading}
                  onClick={handleSubmit} // Utiliza la función login aquí
                >
                  Iniciar sesión
                </button>
              </div>
              <div className={styles.lineFooter}>
                <div className={styles.lineFooterLeft}></div>
                <div className={styles.circulo}>o</div>
                <div className={styles.lineFooterRight}></div>
              </div>
              {/* <div className={styles.buttonQuestion}>
                <Link
                  className={styles.buttonQuestionForm}
                  to="/remember-password"
                >
                  ¿Olvidaste la contraseña?
                </Link>
              </div> */}
            </div>
            {/* Modal para mostrar errores */}
            {openModal && (
              <LoadingInformation
                name="Error de Autenticación"
                description={messageDescription}
                isOpen={openModal}
                onClose={handleCloseModal}
                isLoading={loading}
                responseStatus={errorType}
              />
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;